import React from 'react'
import clsx from 'clsx'

/**
 * StatusBadge - Display status with color-coded badge
 */
const StatusBadge = ({ status, size = 'md' }) => {
  const statusConfig = {
    active: {
      label: 'Active',
      className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    },
    inactive: {
      label: 'Inactive',
      className: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-400',
    },
    enabled: {
      label: 'Enabled',
      className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    },
    disabled: {
      label: 'Disabled',
      className: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-400',
    },
    pending: {
      label: 'Pending',
      className: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
    },
    error: {
      label: 'Error',
      className: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
    },
    success: {
      label: 'Success',
      className: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
    },
    warning: {
      label: 'Warning',
      className: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400',
    },
  }

  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
    lg: 'px-2.5 py-1 text-sm',
  }

  const config = statusConfig[status] || statusConfig.inactive
  const normalizedStatus = typeof status === 'boolean'
    ? (status ? 'active' : 'inactive')
    : status

  const finalConfig = statusConfig[normalizedStatus] || {
    label: String(status),
    className: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-400',
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium rounded-full',
        sizeClasses[size],
        finalConfig.className
      )}
    >
      {finalConfig.label}
    </span>
  )
}

export default StatusBadge
